import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleSettingsModal } from '../../../../../slices/modals/reducer';
import { resetSettingsErr, resetVersionDetails, setSettingsErr, setVersionDetails } from '../../../../../slices/campaigns/reducer';
import { Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap";
import VersionDetails from '../VersionDetails';
import { updateVersion } from '../../../../../slices/campaigns/thunk';
import ErrorAlert from '../../../../../Components/Common/ErrorAlert';
import { replace } from 'redux-first-history';

function SettingsModal() {
  const dispatch = useDispatch();

  const selectState = createSelector(state => state, state => ({
    settingsModal: state.Modal.settingsModal,
    settingsErr: state.Campaign.settingsErr,
    settingsErrMsg: state.Campaign.settingsErrMsg,
    currentCampaign: state.Campaign.currentCampaign,
    version: state.Campaign.version,
    currentVersion: state.Campaign.currentVersion,
    facebookProperties: state.Campaign.facebookProperties,
    isFacebookPropertiesSet: state.Campaign.isFacebookPropertiesSet,
    connectedFeed: state.Campaign.connectedFeed,
    dynamicText: state.Campaign.dynamicText,
    activeDynamicText: state.Campaign.activeDynamicText,
    filteredFontList: state.Campaign.filteredFontList,
    creatives: state.Campaign.creatives,
    uploadLimits: state.Campaign.uploadLimits,
    filteredCreatives: state.Campaign.filteredCreatives,
    title: state.MenuData.title,
  }));
  const {
    settingsModal,
    settingsErr,
    settingsErrMsg,
    currentCampaign,
    version,
    currentVersion,
    isFacebookPropertiesSet,
    facebookProperties,
    connectedFeed,
    dynamicText,
    activeDynamicText,
    filteredFontList,
    creatives,
    uploadLimits,
    filteredCreatives,
    title
  } = useSelector(selectState);

  const [isSubmit, setIsSubmit] = useState(false);
  const [isReset, setIsReset] = useState(false);

  function handleSubmit() {
    setIsSubmit(true);
  }

  function handleClose() {
    dispatch(toggleSettingsModal());
    setIsReset(true);
    setTimeout(() => {
      dispatch(resetVersionDetails());
    }, 300);
  }

  async function submitFunc(values) {
    const res = await dispatch(updateVersion(
      {
        ...values,
        id: currentVersion._id,
        size: filteredCreatives.map(item => item.size),
      }));
    if (res.status === 'ok') {
      dispatch(toggleSettingsModal());
      dispatch(replace(window.location.href, {
        currentCampaign: currentCampaign,
        versions: res.versions,
        currentVersion: res.updatedVersion,
        facebookProperties: facebookProperties,
        isFacebookPropertiesSet: isFacebookPropertiesSet,
        connectedFeed: connectedFeed,
        dynamicText: dynamicText,
        activeDynamicText: activeDynamicText,
        fontRes: filteredFontList,
        creatives: creatives.map((item) => {
          let returnObj = {};
          let keys = Object.keys(item);
          keys.forEach(key => {
            if (key !== 'preview') {
              returnObj[key] = item[key];
            }
          });
          return returnObj;
        }),
        uploadLimits: uploadLimits,
        title: title
      }));
      setIsSubmit(false);
    } else {
      dispatch(setSettingsErr(res?.message));
    }
  }
  return (
    <Modal isOpen={settingsModal} toggle={handleClose} centered size='md'>
      <ModalHeader className='p-3' toggle={handleClose}>
        <b>Settings</b>
        {/* <span className='ms-2 fw-normal'>{(versionDetailState.name || "")}</span> */}
      </ModalHeader>
      <ModalBody className='px-3'>
        <ErrorAlert errorState={settingsErr} errorMessage={settingsErrMsg} resetError={resetSettingsErr} />
        <VersionDetails hiddenSizes={false} isSubmit={isSubmit} isReset={isReset} submitFunc={async (values) => await submitFunc(values)} />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' type='button' onClick={handleClose}>Close</button>
        <button className='btn btn-success' type='submit' onClick={handleSubmit} disabled={settingsErr ? true : false}>
          Save Settings
          {settingsErr ? <Spinner size='sm' className='ms-2'>Loading...</Spinner> : null}
        </button>
      </ModalFooter>
    </Modal>
  )
}

export default SettingsModal
